export default __webpack_public_path__ + "static/media/ava-1.c6f256f6.png";